export enum pageNames {
  HOME = 'Home',
  LOGIN = 'Login',
  LOGOUT = 'Logout',
  FORGOTPASSWORD = 'ForgotPassword',
  RESETPASSWORD = 'ResetPassword',

  CLIENT = 'Client',
  USER = 'User',
  USERPROFILE = 'UserProfile',
  USEREDITORNEW = 'UserEditorNew',
  USEREDITOREXISTING = 'UserEditorExisting',
  PERMISSION = 'Permission',
  PERMISSIONEDITORNEW = 'PermissionEditorNew',
  PERMISSIONEDITOREXISTING = 'PermissionEditorExisting',

  CONTRIBUTOR = 'Contributor',
  CONTRIBUTOREDITORNEW = 'ContributorEditorNew',
  CONTRIBUTOREDITOREXISTING = 'ContributorEditorExisting',
  COMMUNITYRESEARCHCONTENT = 'CommunityResearchContent',
  COMMUNITYRESEARCHEDITOREXISTING = 'CommunityResearchEditorExisting',
  SUBACCOUNTCONTRIBUTOREDITORNEW = 'SubAccountContributorEditorNew',
  SUBACCOUNTCONTRIBUTOREDITOREXISTING = 'SubAccountContributorEditorExisting',
  
  INSTITUTIONSTOCKPLACEMENT = 'InstitutionStockPlacement',
  INSTITUTIONSTOCKPLACEMENTDETAIL= 'InstitutionStockPlacementDetail',

  INSTITUTION = 'Institution',
  INSTITUTIONEDITORNEW = 'InstitutionEditorNew',
  INSTITUTIONEDITOREXISTING = 'InstitutionEditorExisting',
  INSTITUTIONCONTENT = 'InstitutionContent',
  INSTITUTIONCONTENTEDITORNEW = 'InstitutionContentEditorNew',
  INSTITUTIONCONTENTEDITOREXISTING = 'InstitutionContentEditorExisting',

  STREETCALLCONTENT = 'StreetcallContent',
  STREETCALLCONTENTEDITORNEW = 'StreetcallContentEditorNew',
  STREETCALLCONTENTEDITOREXISTING = 'StreetcallContentEditorExisting',

  FFSCONTENT = 'FfsContent',
  FFSCONTENTEDITORNEW = 'FfsContentEditorNew',
  FFSCONTENTEDITOREXISTING = 'FfsContentEditorExisting',
  
  ADBANNER = 'AdBanner',
  ADBANNEREDITORNEW = 'AdBannerEditorNew',
  ADBANNEREDITOREXISTING = 'AdBannerEditorExisting',

  RESEARCH = 'Research',
  RESEARCHEDITOR = 'ResearchEditor',
  RESEARCHEDITORNEW = 'ResearchEditorNew',
  RESEARCHEDITOREXISTING = 'ResearchEditorExisting',
  ALGONEWS = 'AlgoNews',
  ALGONEWSEDITORNEW = 'AlgoNewsEditorNew',
  ALGONEWSEDITOREXISTING = 'AlgoNewsEditorExisting',
  ALGORESEARCH = 'AlgoResearch',
  ALGORESEARCHEDITORNEW = 'AlgoResearchEditorNew',
  ALGORESEARCHEDITOREXISTING = 'AlgoResearchEditorExisting',
  NEWSLETTER = 'Newsletter',
  NEWSLETTEREDITORUPDATE = 'NewsletterEditorUpdate',
  NEWSLETTERDETAILEXISTING = 'NewsletterDetailExisting',
  RESEARCHBLAST = 'ResearchBlast',
  RESEARCHBLASTNEW = 'ResearchBlastNew',
  RESEARCHBLASTEDITOREXISTING = 'ResearchBlastEditorExisting',
  CATEGORY = 'Category',
  CATEGORYEDITORNEW = 'CategoryEditorNew',
  CATEGORYEDITOREXISTING = 'CategoryEditorExisting',
  MASTERTAG = 'Mastertag',
  MASTERTAGNEW = 'MastertagNew',

  HYBRIDSLIDER = 'HybridSlider',
  HYBRIDSLIDERCREATE = 'HybridSliderCreate',
  HYBRIDSLIDERDETAIL = 'HybridSliderDetail',

  TEXTSLIDER = 'TextSlider',
  TEXTSLIDERCREATE = 'TextSliderCreate',
  TEXTSLIDERDETAIL = 'TextSliderDetail',

  SUBSCRIPTION = 'Subscription',
  SUBSCRIPTIONCREATE = 'SubscriptionCreate',
  SUBSCRIPTIONDETAIL = 'SubscriptionDetail',

  STOCKS = 'Stocks',
  ACCOUNT_WALL = 'AccountWall',

  LEGAL = 'Legal',
  LEGALCIRCLEDISCLOSURE = 'LegalCircleDisclosure',
  LEGALCIRCLEDISCLOSURENEW = 'LegalCircleDisclosureNew',

  LEGALINFORMATION = 'LegalInformation',
  LEGALINFORMATIONEDITOR = 'LegalInformationEditor',
}
